import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';

export const Container = styled(Paper)``;
